const kebabToCamelCase = (s) => s?.replace(/-./g, (x) => x[1].toUpperCase())

export function getEventDetailQuery(movieId, site, section = 'moviesInCinemasAvailability') {
    const formattedSite = kebabToCamelCase(site)
    return `{
    entry(site: "${formattedSite}", MovieId: "${movieId}", section: "${section}") {
      ... on moviesInCinemasAvailability_default_Entry {
                  MovieId
                  PictureUrl
                  movie {
              slug
              ... on movies_default_Entry {
                  PictureUrl
                  movieDetailBackground {
                      ... on movieDetailBackground_Asset {
                          title
                          alt
                          url (quality: 70, format: "jpeg", width: 2560)
                      }
                  }
                  moviePoster {
                      ... on moviePoster_Asset {
                          title
                          alt
                          url (quality: 78, format: "jpeg", width: 768)
                      }
                  }
                  CSFD {
                      ... on CSFD_base_BlockType {
                          Genres
                          Photos {
                              Url
                          }
                      }
                  }
              }
          }
          movieGroup {
              slug
              ... on movies_default_Entry {
                  MovieId
                  PictureUrl
                  movieDetailBackground {
                      ... on movieDetailBackground_Asset {
                          title
                          alt
                          url (quality: 70, format: "jpeg", width: 2560)
                      }
                  }
                  moviePoster {
                      ... on moviePoster_Asset {
                          title
                          alt
                          url (quality: 78, format: "jpeg", width: 768)
                      }
                  }
                  CSFD {
                      ... on CSFD_base_BlockType {
                          Photos {
                              Url
                          }
                      }
                  }
              }
          }
                  
      }
    }
  }`
}

export function getSeatsAndHallQuery(site) {
    const formattedSite = kebabToCamelCase(site)
    return `{
        seatsEntries(site: "${formattedSite}") {
      ... on seats_default_Entry {
        seatId
        seatTitle
        seatDescription
        seatProperties {
          key
          value
        }
        image: imageMobile {
          ... on AssetInterface {
            title
            url(quality: 70, format: "jpeg", width: 768, mode: "fit")
          }
        }
        seatIcon {
          ... on AssetInterface {
            title
            url
          }
        }
        cinemaHalls {
          ... on cinemaHalls_default_Entry {
                      cinemaHallTitle
            cinemaHallDescription
            cinemaHallProperties {
              key
              value
            }
            image: imageMobile {
              ... on AssetInterface {
                title
                url(quality: 70, format: "jpeg", width: 768, mode: "fit")
              }
            }
          }
        }
      }
    }
}`
}

export function getSeatsQuery(site, cinemaHallId) {
    const formattedSite = kebabToCamelCase(site)
    return `{
  seatsEntries(site: "${formattedSite}", cinemaHalls:["${cinemaHallId}"]) {
    ... on seats_default_Entry {
      id
      title
      seatId
      seatTitle
      seatDescription
      seatProperties {
        key
        value
      }
      image: imageMobile {
        ... on AssetInterface {
          title
          url(quality: 70, format: "jpeg", width: 768, mode: "fit")
        }
      }
      seatIcon {
        ... on AssetInterface {
          title
          url
        }
      }
      cinemaHalls {
        ... on cinemaHalls_default_Entry {
                    cinemaHallTitle
          cinemaHallDescription
          cinemaHallProperties {
            key
            value
          }
          image: imageMobile {
            ... on AssetInterface {
              title
              url(quality: 70, format: "jpeg", width: 768, mode: "fit")
            }
          }
        }
      }
    }
  }
}`
}

export function getHallInfoDataQuery(site, objectId) {
    const formattedSite = kebabToCamelCase(site)
    return `{
      cinemaHallsEntries(site: "${formattedSite}", ObjectId:"${objectId}") {
        ... on cinemaHalls_default_Entry {
          id
          CinemaId
          cinemaHallTitle
          ObjectId
          OrganizationId
          cinemaHallDescription
          cinemaHallProperties {
            key
            value
          }
          Properties {
            Name
            Code
          }
          imageMobile {
            url
            alt
          }
        }
      } 
    }`
}

export function getGDPRQuery(slug) {
    return `{
        entry(
          site: "default"
          slug: "${slug}"
          section: "pages"
          type: ["default", "cinemaHall"]
        ) {
          ... on pages_default_Entry {
            id
            componentsBuilder {
              ... on componentsBuilder_wysiwyg_BlockType {
                html
              }
            }
          }
        }
      }`
}
